import {
  AnchorButton,
  AnchorLinkButton,
  Spacer,
  Text,
} from "@vericus/cadmus-ui";

import UnauthorisedImg from "@/assets/illustrations/unauthorised.png";

import { LMSReturnLink } from "../lms-return-link";
import { Actions, Grid, GridContent, GridImg } from "./styles";

export function UnauthorizedError() {
  return (
    <Grid>
      <GridImg
        src={UnauthorisedImg}
        alt="An illustration of a woman reading a map"
      />
      <GridContent>
        <Text kind="displayTwo">
          {"You're"} not logged into this Cadmus Assessment
        </Text>
        <Text kind="lead">
          Go to your Learning Management System (Blackboard, Canvas, Moodle or
          D2L) and click the Cadmus Assessment link. If that {"doesn't"} work,
          you may be using an unsupported browser. Try switching to{" "}
          <AnchorLinkButton
            inline
            kind="solid"
            external
            href="https://www.google.com/chrome/browser/desktop/index.html"
          >
            Chrome
          </AnchorLinkButton>
        </Text>

        <Spacer spacing={27} />
        <Actions>
          <LMSReturnLink />
          <AnchorButton
            kind="secondary"
            external
            href="https://support.cadmus.io/kb-tickets/new"
          >
            Contact us for help
          </AnchorButton>
        </Actions>
        <Spacer spacing={72} />
      </GridContent>
    </Grid>
  );
}
